import {format} from "date-fns";

export const formDateformat = (date) => {
    console.log("formDateformat",date,format(date, "yyyy/MM/dd"));
    return format(date, "yyyy/MM/dd");
};
